import type * as React from "react";
import { Box } from "@mui/material";
import HeaderLogo from "assets/images/GL-Logo.svg";
import AccountExitLink from "components/v3/sharedComponents/AccountExitLink";
import Stepper from "components/v3/sharedComponents/Stepper";
import { PATHS } from "constants/pathConstants";

export type UnpaidInviteRegistrationStepperProps = {
  activeStepIndex: number;
};

type SubStep = {
  label: string;
  stepIndex: number;
};

type Step = {
  longName: string;
  shortName: string;
  stepIndex: number;
  subSteps: SubStep[];
};

const UnpaidInviteRegistrationStepper: React.FC<
  UnpaidInviteRegistrationStepperProps
> = ({ activeStepIndex }) => {
  const steps: Step[] = [
    {
      longName: "Account",
      shortName: "Account",
      stepIndex: 0,
      subSteps: []
    },
    {
      longName: "Profile",
      shortName: "Profile",
      stepIndex: 1,
      subSteps: []
    },
    {
      longName: "Payment",
      shortName: "Payment",
      stepIndex: 2,
      subSteps: []
    }
  ];

  const greeting = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: (theme) => `calc(${theme.spacing(2)} + 15px)`,
        paddingTop: { md: "15px", xs: "calc(8px + 15px)" },
        width: "100%"
      }}
    >
      <AccountExitLink
        to={PATHS.ACCOUNT_MANAGEMENT}
        label="← Back to account"
      />
      <Box sx={{ maxWidth: 175, width: "100%" }}>
        <Box
          alt="Genomic Life"
          component="img"
          src={HeaderLogo}
          sx={{ height: "auto", maxWidth: "100%" }}
        />
      </Box>
    </Box>
  );

  return (
    <Stepper
      activeStepIndex={activeStepIndex}
      greeting={greeting}
      headerShown
      horizontalStripSurface="transparent"
      layout="horizontal"
      showMobileGreeting
      steps={steps}
    />
  );
};

export default UnpaidInviteRegistrationStepper;
